import { z } from 'zod';
import { signupEmailSchema } from '../../auth/signup-form.js';
/**
 * Asking for the verification email again (account sign-up `technical.md`,
 * `POST /api/dashboard/verification-emails`). A Groundly endpoint rather than a
 * Better Auth route, because the answer must reveal nothing about the address
 * (`patterns/api-conventions.md`, 1, Exception).
 *
 * The address is checked with sign-up's own email rule, so the messages match
 * the sign-up form's.
 */
export const verificationEmailRequestSchema = z.object({
    email: signupEmailSchema,
});
/**
 * `@PublicRoute()`. Always `204` with nothing to return, whatever the address
 * is: unknown, verified, removed, unverified or over its cap.
 */
export const requestVerificationEmail = {
    method: 'POST',
    path: '/api/dashboard/verification-emails',
    params: z.object({}),
    query: z.object({}),
    body: verificationEmailRequestSchema,
    response: z.void(),
};
//# sourceMappingURL=verification-emails.js.map